import axiosInstance from './config/api';

export type CommunicationMedium = 'CALL' | 'SMS' | 'BOTH';

export type WorkflowPhoneNumber = {
    phoneNumber: string;
    outboundTrunkSid: string;
    provider: string;
    communicationMedium: CommunicationMedium;
};

export type WorkflowPhoneNumbersParams = {
    workflowId: string;
    currentPage?: number;
    perPage?: number;
};

export type WorkflowPhoneNumbersResponse = {
    data: WorkflowPhoneNumber[];
    pagination: {
        totalPages: number;
        totalRecords: number;
        currentPage: number;
        perPage: number;
    };
};

export const getWorkflowPhoneNumbers = async (params: WorkflowPhoneNumbersParams) => {
    const { data } = await axiosInstance.get<WorkflowPhoneNumbersResponse>('/telephony/workflow-phone-numbers', {
        params,
    });
    return data;
};
